import classNames from 'classnames';
import { FlexContainer, Txt } from 'components';
import styles from './NotCreated.module.scss';

/**
 * NotCreated
 *
 * @return {JSX.Element}
 */
const NotCreated = ({ className }) => {
  return (
    <FlexContainer
      className={classNames(
        styles.NotCreated,
        className,
        NotCreated.displayName
      )}
      column
      gap
    >
      <Txt bold>⏳ Agreement in review</Txt>
      <Txt regular>
        Your landlord is currently reviewing the tenancy agreement. When your
        landlord is ready, Propa will email a link with the agreement to all the
        relevant parties.
      </Txt>
      <Txt regular>
        When you recieve the email you will need to digitally sign it using the
        mobile number you provided.
      </Txt>
    </FlexContainer>
  );
};

NotCreated.displayName = 'NotCreated';

export default NotCreated;
